import { StoreState } from 'state/rootReducer';

export const getUserSubscriptionPlan = ({ userInfo }: StoreState) =>
  userInfo.userData.subscriptionPlan;

export const getUserEmail = ({ userInfo }: StoreState) =>
  userInfo.userData.userEmail;
